import React from 'react';
import { withLoading } from '@app/hocs/withLoading.hoc';

type LazyPageComponent<TProps = Record<string, never>> =
  React.ComponentType<TProps>;

export const createLazyPage = <TProps,>(
  factory: () => Promise<{ default: React.ComponentType<TProps> }>
): LazyPageComponent<TProps> =>
  withLoading(
    React.lazy(factory) as unknown as React.ComponentType<TProps>
  ) as LazyPageComponent<TProps>;
